module.exports = __webpack_public_path__ + "img/Empty Cart Artwork@2x.9b512950.png";